import { TchatMessage } from './tchat-message';
import { TchatRoom } from './tchat-room';
import { TchatUser } from './tchat-user';

export class SavedTchatRoom extends TchatRoom {
    title: string;

    constructor(public override users: TchatUser[]) {
        super(users);
    }

    public static override createFormCopy(chatRoom: TchatRoom): SavedTchatRoom {
        const instance = new SavedTchatRoom(chatRoom.users);
        instance.guid = chatRoom.guid;
        instance.messages = chatRoom.messages.map((m) => TchatMessage.createFormCopy(m));
        instance.notifications = chatRoom.notifications;
        return instance;
    }
}
